import { translations as translationsEn } from './en_US';

export type TranslationsKeys = keyof typeof translationsEn;
export type Translations = Record<string, Record<string, string>> | JSON;

export const BASE_LANGUAGE = 'default';

const translations = {
    [BASE_LANGUAGE]: { translation: translationsEn },
};

export default translations;
